export const plannedMaintenance = 'PLANNED_MAINTENANCE';
